export default __webpack_public_path__ + "resources/icons/n412-5741.webp";